export default "__VITE_ASSET__CjhdF1sb__"